import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";

function TabPanel(props) {
  const { children = null, index, value, customMargin = false } = props;
  const isActive = value === index;

  return (
    <div
      role="tabpanel"
      id={`form-tabpanel-${index}`}
      aria-labelledby={`form-tab-${index}`}
      tabIndex={isActive ? "0" : "-1"}
      aria-hidden={!isActive}
    >
      <Box
        sx={[customMargin ? { padding: "1rem" } : { padding: "1rem 0 2rem 0" }]}
      >
        {children}
      </Box>
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  customMargin: PropTypes.bool,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
TabPanel.defaultProps = {
  children: null,
  customMargin: false,
};

export default TabPanel;
